(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-material-type-attribute', {
            parent: 'entity',
            url: '/custom-material-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attributes.html',
                    controller: 'CustomMaterialTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-material-type-attribute-detail', {
            parent: 'custom-material-type-attribute',
            url: '/custom-material-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-detail.html',
                    controller: 'CustomMaterialTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomMaterialTypeAttribute', function($stateParams, CustomMaterialTypeAttribute) {
                    return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-material-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-material-type-attribute-detail.edit', {
            parent: 'custom-material-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-material-type-attribute.new', {
            parent: 'custom-material-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('custom-material-type-attribute');
                });
            }]
        })*/
        
        .state('custom-material-type-attribute.new', {
			parent : 'custom-material-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-material-type-attribute.edit', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-material-type-attribute.edit', {
			parent : 'custom-material-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customMaterialTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customMaterialTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomMaterialTypeAttribute', function($stateParams, CustomMaterialTypeAttribute) {
					return CustomMaterialTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-material-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-material-type-attribute.delete', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-delete-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-material-type-attribute', {
            parent: 'entity',
            url: '/custom-material-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attributes.html',
                    controller: 'CustomMaterialTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-material-type-attribute-detail', {
            parent: 'custom-material-type-attribute',
            url: '/custom-material-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customMaterialTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-detail.html',
                    controller: 'CustomMaterialTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customMaterialTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomMaterialTypeAttribute', function($stateParams, CustomMaterialTypeAttribute) {
                    return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-material-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-material-type-attribute-detail.edit', {
            parent: 'custom-material-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-material-type-attribute.new', {
            parent: 'custom-material-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('custom-material-type-attribute');
                });
            }]
        })
        .state('custom-material-type-attribute.edit', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-material-type-attribute.delete', {
            parent: 'custom-material-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-material-type-attribute/custom-material-type-attribute-delete-dialog.html',
                    controller: 'CustomMaterialTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomMaterialTypeAttribute', function(CustomMaterialTypeAttribute) {
                            return CustomMaterialTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-material-type-attribute', null, { reload: 'custom-material-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/
